// Logos depuis frontend/src/assets/images/payment/ (imports relatifs → URLs correctes en dev et en prod)
import visaMastercard from '../assets/images/payment/visamastercard.png';
import postFinance from '../assets/images/payment/PostFinance_Logo.svg.png';
import virement from '../assets/images/payment/virement.png';
import postepay from '../assets/images/payment/png-transparent-postepay-icon-thumbnail.png';
import twint from '../assets/images/payment/lg-688f14786f85f-TWINT.webp';
import revolut from '../assets/images/payment/Revolut-Logo.png';

export const paymentLogos = {
  'visamastercard.png': visaMastercard,
  'PostFinance_Logo.svg.png': postFinance,
  'virement.png': virement,
  'png-transparent-postepay-icon-thumbnail.png': postepay,
  'lg-688f14786f85f-TWINT.webp': twint,
  'Revolut-Logo.png': revolut,
  twint,
  revolut
};

export const getPaymentLogo = (logoName) => paymentLogos[logoName] || null;
